<template>
  <div>
    <Header></Header>
    <router-view />
    <Footer></Footer>
    <!-- <a
      target="_blank"
      href="http://wpa.qq.com/msgrd?v=3&uin=75829644&site=qq&menu=yes"
      style="position:fixed;top:150px;left:0px;z-index:99"
      v-if="!IM"
    > -->
    <div style="position:fixed;top:150px;left:0px;z-index:99" v-if="!IM" @click="IMFun">
      <img
        src="/static/images/full_ask.png"
        alt="在线客服"
        title="在线客服"
        style="width:100px;height:auto;margin:0;"
      />
      <span
        style="position: fixed;top:150px;left:70px;color:#000;font-size: 20px;display: block;width: 24px;text-align: center;line-height: 24px;"
        @click.stop="IM=true"
      >x</span>
    </div>
    <!--ICRD开放注册允许选课后放开注释启动功能，ICRD注册通道，更换图片20220308byfgq-->
    <!-- <div
      style="position:fixed;top:400px;left:0px;z-index:99;cursor:pointer"
      v-if="!register"
      @click="loginState=true"
    >
      
      <img
        src="/static/images/register.png"
        alt="ICRD注册"
        title="ICRD注册"
        style="width:100px;height:auto;margin:0;"
      />
      <span
        style="position: fixed;top:380px;left:76px;color:#000;font-size: 20px;display: block;width: 24px;text-align: center;line-height: 24px;cursor:pointer"
        @click.stop="register=true"
      >x</span>
    </div> -->
    <!--ICRD开放注册允许选课后放开注释启动功能，更换图片20220308byfgq-->
    <div id="registerOnly" @click="loginState=false" v-if="loginState">
      <div class="frame" @click.stop>
        <div class="head">
          <img src="/static/logo.png" style="opacity:0"/>
          <span class="zh-remove" @click="loginState=false"></span>
        </div>
        <div class="content">
          <input
            type="text"
            class="phone"
            placeholder="请输入您的手机号码"
            v-model="phone"
            @focus="codes=false"
          />
          <p></p>
          <input
            type="text"
            class="code"
            placeholder="请输入手机验证码"
            v-model="code"
            @keyup.enter="_regist"
          />
          <button class="buttonCode" @click="_sendSMS" ref="code">{{seconds}}</button>
          <p>{{message}}</p>
          <button @click="_regist()">下一步</button>
        </div>
      </div>
    </div>
    <div id="registerOnly" @click="nameAndId=false" v-if="nameAndId">
      <div class="frame" @click.stop  style="height:370px">
        <div class="head">
          <img src="/static/logo.png" style="opacity:0"/>
          <span class="zh-remove" @click="nameAndId=false"></span>
        </div>
        <div class="content">
          <input
            type="text"
            class="phone"
            placeholder="请输入您的真实姓名"
            v-model="name"
            @focus="codes=false"
          />
          <p></p>
          <input
            type="text"
            class="phone"
            placeholder="请输入您的身份证号码"
            v-model="id"
            @keyup.enter="_updateRegistNameAndId"
          />
          <p></p>
          <input
            type="text"
            class="phone"
            placeholder="请输入您的单位全称"
            v-model="company"
            @keyup.enter="_updateRegistNameAndId"
          />
          <p>{{message}}</p>
          <button @click="_updateRegistNameAndId()">下一步</button>
        </div>
      </div>
    </div>
    <div id="registerOnly" v-if="payTip">
      <div class="frame" @click.stop>
        <div class="head">
          <img src="/static/logo.png" style="opacity:0"/>
          <span class="zh-remove" @click="payTip=false" v-if="payStatus==2"></span>
        </div>
        <div class="content" v-if="payStatus==0">
          <p style="margin-bottom:10px">请选择支付金额</p>
          <span @click="selectPay=800" :class="{selectPay:selectPay==800}">800元</span>
          <span @click="selectPay=200" :class="{selectPay:selectPay==200}">200元</span>  <!--200  20230327byfgq-->
          <button @click="_payTip()">立即支付</button>
        </div>
        <div class="content" v-if="payStatus==1">
          <p style="margin-bottom:60px;margin-top:20px;font-size:16px">请在新打开的页面完成支付后，点击下方“已完成”按钮，然后点击右上角登录按钮登录并完成后续操作。</p>
          <button @click="payTip=false">已完成</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from "@/modules/footer.vue";
import {
  sendSMS,
  phoneRegist,
  updateRegistNameAndId,
  baseURL,
  checkPayStatus
} from "@/assets/js/axios.js";

export default {
  name: "App",
  data() {
    return {
      register: false,
      IM: false,
      phone: "",
      code: "",
      loginState: false,
      nameAndId: false,
      payTip: false,
      payStatus: 0,
      message: "",
      seconds: "发送验证码",
      name: "",
      id: "",
      company: "",
      timer: "",
      selectPay: 800
    };
  },
  methods: {
    IMFun() {
      this.$confirm("关于集成电路继续教育相关问题（包含如何注册以及注册后的全部问题），请添加微信Zhang_Muliin解决，在线客服不回答这类问题，谢谢。", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "退出"
      }).then(() => {
        this.$confirm("请再次确定所提问题与继续教育无关", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        }).then(() => {
          // <!--更改客服的qq号码20220308byfgq-->
          window.open("http://wpa.qq.com/msgrd?v=3&uin=47242304&site=qq&menu=yes", "_blank")
        }).catch(() => {

        });
      }).catch(() => {
      });
    },
    _payTip() {
      window.open(baseURL + "/pay/recharge?amount=" + this.selectPay, "_blank");
      this.payStatus = 1;
    },
    _updateRegistNameAndId() {
      if (!this.name) {
        this.message = "请输入您的真实姓名";
        return;
      }
      if (!this.id) {
        this.message = "请输入您的身份证号码";
        return;
      }
      if (!this.company) {
        this.message = "请输入您的单位全称";
        return;
      }
      updateRegistNameAndId(this.name, this.id, this.company).then(data => {
        if (parseInt(data.code) === 1) {
          this.nameAndId = false;
          this.payTip = true;
          this.payStatus = 0;
        } else {
          this.message = data.msg || "未知错误请重试";
        }
      });
    },
    _sendSMS() {
      if (this.phone) {
        if (this.seconds === "发送验证码" || this.seconds === "重新发送") {
          this.seconds = "60s";
          let that = this;
          this.$refs.code.style.background = "#ddd";
          let seconds = setInterval(() => {
            let x = parseInt(that.seconds);
            that.seconds = --x + "s";
            if (that.seconds === "0s") {
              that.seconds = "重新发送";
              clearInterval(seconds);
              this.$refs.code.style.background = "#109eff";
            }
          }, 1000);
          sendSMS(this.phone).then(data => {
            if (parseInt(data.code) !== 1) {
              this.message = data.msg || "未知错误，请重试";
              that.seconds = "重新发送";
              clearInterval(seconds);
              this.$refs.code.style.background = "#109eff";
            }
          });
        }
      } else {
        this.message = "请输入您的手机号码";
      }
    },
    _regist() {
      if (!this.phone) {
        this.message = "请输入您的手机号码";
        return;
      }
      if (!this.code) {
        this.message = "请输入手机验证码";
        return;
      }
      phoneRegist(this.phone, this.code).then(data => {
        if (parseInt(data.code) === 1) {
          this.loginState = false;
          this.nameAndId = true;
        } else {
          this.message = data.msg || "未知错误请重试";
        }
      });
    }
  },
  components: {
    Footer
  }
};
</script>

<style lang="less">
html,
body,
h2,
input,
button,
p {
  margin: 0;
  padding: 0;
}
body {
  font-size: 16px;
  background: #f8f8f8;
}
.clear:after {
  display: block;
  content: "";
  clear: both;
}
a {
  text-decoration: none;
  color: #000;
}
#registerOnly {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
  font-size: 0;
  .frame {
    width: 426px;
    height: 346px;
    background: #fff;
    border-radius: 10px;
    position: relative;
    top: 50%;
    left: 50%;
    margin-left: -213px;
    margin-top: -173px;
    .head {
      height: 42px;
      padding: 30px 30px 10px;
      color: #109eff;
      img {
        width: 95px;
        height: 35px;
      }
      span.zh-remove {
        display: inline-block;
        position: relative;
        width: 16px;
        height: 16px;
        top: -20px;
        left: 266px;
        cursor: pointer;
      }
      span.zh-remove:before {
        display: block;
        content: "";
        position: absolute;
        width: 2px;
        height: 16px;
        background: #aaa;
        transform: rotate(-45deg);
      }
      span.zh-remove:after {
        display: block;
        content: "";
        position: absolute;
        width: 2px;
        height: 16px;
        background: #aaa;
        transform: rotate(45deg);
      }
    }
    .content {
      margin-top: 16px;
      padding: 0 30px;
      text-align: center;
      input {
        border: 1px solid #d1d1d1;
        outline: none;
        border-radius: 4px;
        padding-left: 16px;
        width: 350px;
        height: 38px;
      }
      input:focus {
        border-color: #109eff;
      }
      input.code {
        width: 230px;
      }
      p {
        height: 20px;
        padding-top: 4px;
        font-size: 12px;
        color: red;
        text-align: center;
      }
      span{
        display: inline-block;
        width: 100px;
        height: 30px;
        color:#109eff;
        border: 1px solid #109eff;
        font-size: 16px;
        text-align: center;
        border-radius: 4px;
        margin:20px 20px;
        line-height: 30px;
        cursor: pointer;
      }
      .selectPay{
        background: #109eff;
        color:#fff;
      }
      button {
        width: 366px;
        height: 40px;
        background: #109eff;
        border: none;
        border-radius: 4px;
        color: #fff;
        font-size: 16px;
        cursor: pointer;
        outline: none;
        margin-top: 10px;
      }
      .buttonCode {
        width: 108px;
        height: 40px;
        margin-left: 10px;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue